import { TabsTheme } from '@/components/Tabs/theme';
import { GenericSlotFactory } from 'base/components/GenericSlot';

const $ = GenericSlotFactory({ theme: TabsTheme });

const Base = $({ as: 'ul', slot: 'base' });
const Tab = $({ as: 'li', slot: 'tab' });

export const Tabs = Object.assign(Base, { Tab });
